import { render, staticRenderFns } from "./TemplateOrderMultiUpload.vue?vue&type=template&id=0f2763ec&scoped=true"
import script from "./TemplateOrderMultiUpload.vue?vue&type=script&lang=js"
export * from "./TemplateOrderMultiUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2763ec",
  null
  
)

export default component.exports